export const FIELD_INSP_TITLE = "Template Fields";

export const FIELD_INSP_SUBTITLE =
  "All the form fields in template along with their type and data source are listed here";

export const SELECT_DATASOURCE_MSG_TITLE = "Query data from external source";

export const SELECT_DATASOURCE_MSG_SUBTITLE =
  "Revv can help you fetching data from outside source and autofill/display/render in the document form fields, select and external from below to get started.";

export const CHNG_OBJ_WARNING_TITLE =
  " ⚠️ Changing object will cause data loss ";

export const CHNG_OBJ_WARNING_SUBTITLE =
  "You're about to switch to another object. In case you have created any mappings, you will lose the progress. You can only use one object from a data source for mapping to Revv fields. ";

export const DATE_FILTER_SUBTITLE =
  "Only data created during the selected time period will be fetched";

export const DOCUMENT_CREATE_SUCCESS_MSG = "Your documents are being created.";

export const START_SYNC = "Sync now";
